"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "KanbansService", {
    enumerable: true,
    get: function() {
        return KanbansService;
    }
});
const _common = require("@nestjs/common");
const _nocodbsdk = require("nocodb-sdk");
const _viewwebhookmanager = require("~/utils/view-webhook-manager");
const _apphooksservice = require("~/services/app-hooks/app-hooks.service");
const _helpers = require("~/helpers");
const _catchError = require("~/helpers/catchError");
const _models = require("~/models");
const _NocoCache = /*#__PURE__*/ _interop_require_default(require("~/cache/NocoCache"));
const _globals = require("~/utils/globals");
const _NocoSocket = /*#__PURE__*/ _interop_require_default(require("~/socket/NocoSocket"));
function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function _ts_decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function _ts_metadata(k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
}
let KanbansService = class KanbansService {
    async kanbanViewGet(context, param, ncMeta) {
        return await _models.KanbanView.get(context, param.kanbanViewId, ncMeta);
    }
    async kanbanViewCreate(context, param, ncMeta) {
        var _param_kanban_fk_cover_image_col_id, _param_viewWebhookManager;
        var _param_kanban_title, _param_user, _param_user1;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/ViewCreateReq', param.kanban);
        if (context.schema_locked) {
            _catchError.NcError.get(context).schemaLocked();
        }
        const model = await _models.Model.get(context, param.tableId, ncMeta);
        let fk_cover_image_col_id = (_param_kanban_fk_cover_image_col_id = param.kanban.fk_cover_image_col_id) != null ? _param_kanban_fk_cover_image_col_id : null;
        // if attachment field not mapped(undefined) and at-least one attachment field exists in the model
        // map the first attachment field, skip if duplicating
        // Skip if copy_from_id is present(which means duplicating)
        if (param.kanban.fk_cover_image_col_id === undefined && !param.kanban.copy_from_id) {
            const attachmentField = (await model.getColumns(context, ncMeta)).find((column)=>column.uidt === _nocodbsdk.UITypes.Attachment);
            if (attachmentField) {
                fk_cover_image_col_id = attachmentField.id;
            }
        }
        param.kanban.title = (_param_kanban_title = param.kanban.title) == null ? void 0 : _param_kanban_title.trim();
        const existingView = await _models.View.getByTitleOrId(context, {
            titleOrId: param.kanban.title,
            fk_model_id: param.tableId
        }, ncMeta);
        if (existingView) {
            _catchError.NcError.get(context).duplicateAlias({
                type: 'view',
                alias: param.kanban.title,
                label: 'title',
                base: context.base_id,
                additionalTrace: {
                    table: param.tableId
                }
            });
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(param.tableId)).forCreate();
        const { id } = await _models.View.insertMetaOnly(context, {
            view: _extends({}, param.kanban, {
                // todo: sanitize
                fk_model_id: param.tableId,
                type: _nocodbsdk.ViewTypes.KANBAN,
                base_id: model.base_id,
                source_id: model.source_id,
                created_by: (_param_user = param.user) == null ? void 0 : _param_user.id,
                owned_by: param.ownedBy || ((_param_user1 = param.user) == null ? void 0 : _param_user1.id),
                fk_cover_image_col_id
            }),
            model,
            req: param.req
        }, ncMeta);
        const view = await _models.View.get(context, id, ncMeta);
        await _NocoCache.default.appendToList(context, _globals.CacheScope.VIEW, [
            view.fk_model_id
        ], `${_globals.CacheScope.VIEW}:${id}`);
        await this.initializeKanbanMetaForGroupingColumn(context, view, ncMeta);
        let owner = param.req.user;
        if (param.ownedBy) {
            owner = await _models.User.get(param.ownedBy, ncMeta);
        }
        this.appHooksService.emit(_nocodbsdk.AppEvents.KANBAN_CREATE, {
            view: _extends({}, view, param.kanban),
            user: param.user,
            req: param.req,
            owner,
            context
        });
        await view.getView(context);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_create',
                payload: view
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return view;
    }
    async kanbanViewUpdate(context, param, ncMeta) {
        var _param_viewWebhookManager;
        var _param_req_user;
        (0, _helpers.validatePayload)('swagger.json#/components/schemas/KanbanUpdateReq', param.kanban);
        const view = await _models.View.get(context, param.kanbanViewId, ncMeta);
        if (!view) {
            _catchError.NcError.get(context).viewNotFound(param.kanbanViewId);
        }
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(view.fk_model_id)).withViewId(view.id)).forUpdate();
        const oldKanbanView = await _models.KanbanView.get(context, param.kanbanViewId, ncMeta);
        const groupingColumnChanged = oldKanbanView.fk_grp_col_id !== param.kanban.fk_grp_col_id;
        await _models.KanbanView.update(context, param.kanbanViewId, param.kanban, ncMeta);
        if (groupingColumnChanged) {
            const updatedView = await _models.View.get(context, param.kanbanViewId, ncMeta);
            await this.initializeKanbanMetaForGroupingColumn(context, updatedView, ncMeta);
        }
        let owner = param.req.user;
        if (view.owned_by && view.owned_by !== ((_param_req_user = param.req.user) == null ? void 0 : _param_req_user.id)) {
            owner = await _models.User.get(view.owned_by, ncMeta);
        }
        const kanbanView = await _models.KanbanView.get(context, param.kanbanViewId, ncMeta);
        this.appHooksService.emit(_nocodbsdk.AppEvents.KANBAN_UPDATE, {
            view: view,
            oldKanbanView,
            kanbanView: kanbanView,
            req: param.req,
            owner,
            context
        });
        await view.getView(context);
        _NocoSocket.default.broadcastEvent(context, {
            event: _nocodbsdk.EventType.META_EVENT,
            payload: {
                action: 'view_update',
                payload: view
            }
        }, context.socket_id);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(view.id)).emit();
        }
        return view;
    }
    /**
   * Initialize or update kanban meta for the grouping column
   */ async initializeKanbanMetaForGroupingColumn(context, view, ncMeta) {
        const kanbanView = await _models.KanbanView.get(context, view.id, ncMeta);
        if (!kanbanView.fk_grp_col_id) {
            return; // No grouping column set
        }
        const model = await _models.Model.get(context, view.fk_model_id, ncMeta);
        const column = (await model.getColumns(context, ncMeta)).find((col)=>col.id === kanbanView.fk_grp_col_id);
        if (!column || column.uidt !== _nocodbsdk.UITypes.SingleSelect) {
            return; // Only handle SingleSelect columns
        }
        // Update groupingFieldColumn in view meta
        const viewMeta = (0, _nocodbsdk.parseProp)(view == null ? void 0 : view.meta) || {};
        await _models.View.update(context, view.id, _extends({}, view, {
            meta: _extends({}, viewMeta, {
                groupingFieldColumn: column
            })
        }));
        // Update kanban stack meta
        const colOptions = await column.getColOptions(context);
        if (colOptions == null ? void 0 : colOptions.options) {
            const stackMetaObj = (0, _nocodbsdk.parseProp)(kanbanView.meta) || {};
            if (!stackMetaObj[column.id]) {
                stackMetaObj[column.id] = [];
            }
            // Build new stack meta based on column options
            const newStackMeta = [];
            const existingStacks = stackMetaObj[column.id] || [];
            // Add uncategorized stack first (preserve its existing order if it exists)
            const existingUncategorized = existingStacks.find((stack)=>stack.id === 'uncategorized');
            const uncategorizedStack = existingUncategorized || {
                id: 'uncategorized',
                title: null,
                order: 0,
                color: '#6A7184',
                collapsed: false
            };
            newStackMeta.push(uncategorizedStack);
            // Process each column option, preserving existing order when possible
            let currentMaxOrder = Math.max(...existingStacks.map((s)=>s.order || 0), 0);
            for (const option of colOptions.options){
                const existingStack = existingStacks.find((stack)=>stack.id === option.id);
                if (existingStack) {
                    // Update existing stack with new option data but preserve order and collapsed state
                    newStackMeta.push(_extends({}, option, {
                        order: existingStack.order,
                        collapsed: existingStack.collapsed || false
                    }));
                } else {
                    // Add new stack for new option - assign next available order
                    currentMaxOrder += 1; // Increment for each new item
                    newStackMeta.push(_extends({}, option, {
                        order: currentMaxOrder,
                        collapsed: false
                    }));
                }
            }
            // Sort by preserved/assigned order
            newStackMeta.sort((a, b)=>(a.order || 0) - (b.order || 0));
            // Update kanban view meta
            stackMetaObj[column.id] = newStackMeta;
            await _models.KanbanView.update(context, kanbanView.fk_view_id, {
                meta: stackMetaObj
            });
        }
    }
    async kanbanOptionsReorder(context, param, ncMeta) {
        var _param_viewWebhookManager, _ref, _parseProp;
        var _parseProp1;
        const kanbanView = await this.kanbanViewGet(context, param, ncMeta);
        const modelView = await _models.View.get(context, kanbanView.fk_view_id, ncMeta);
        const viewWebhookManager = (_param_viewWebhookManager = param.viewWebhookManager) != null ? _param_viewWebhookManager : (await (await new _viewwebhookmanager.ViewWebhookManagerBuilder(context, ncMeta).withModelId(modelView.fk_model_id)).withViewId(modelView.id)).forUpdate();
        const model = await _models.Model.get(context, modelView.fk_model_id, ncMeta);
        const column = (await model.getColumns(context, ncMeta)).find((col)=>col.id === kanbanView.fk_grp_col_id);
        if (!column) {
            _catchError.NcError.get(context).fieldNotFound(kanbanView.fk_grp_col_id);
        }
        const options = (await column.getColOptions(context)).options;
        const metaOptions = (_ref = (_parseProp1 = (0, _nocodbsdk.parseProp)(kanbanView.meta)) == null ? void 0 : _parseProp1[column.id]) != null ? _ref : [];
        if (metaOptions.length === 0) {
            metaOptions.push({
                id: 'uncategorized',
                title: null,
                order: 1,
                color: '#6A7184',
                collapsed: false
            });
        }
        for (const option of options){
            if (!metaOptions.some((k)=>k.id === option.id)) {
                metaOptions.push(_extends({}, option, {
                    order: metaOptions.length,
                    collapsed: false
                }));
            }
        }
        let maxOrder = 1;
        const optionsOrderMap = param.optionsOrder.reduce((acc, val, idx)=>{
            acc[val] = idx + 1;
            return acc;
        }, {});
        const unorderedMetaOptions = [];
        for (const metaOption of metaOptions){
            if (metaOption.id === 'uncategorized') {
                metaOption.order = 1;
            } else if (optionsOrderMap[metaOption.title]) {
                metaOption.order = optionsOrderMap[metaOption.title];
                maxOrder = Math.max(metaOption.order, maxOrder);
            } else {
                unorderedMetaOptions.push(metaOption);
            }
        }
        unorderedMetaOptions.forEach((opt, idx)=>{
            opt.order = maxOrder + idx + 1;
        });
        return await this.kanbanViewUpdate(context, {
            kanbanViewId: param.kanbanViewId,
            kanban: _extends({}, kanbanView, {
                meta: _extends({}, (_parseProp = (0, _nocodbsdk.parseProp)(kanbanView.meta)) != null ? _parseProp : {}, {
                    [column.id]: metaOptions.sort((a, b)=>a.order - b.order)
                })
            }),
            req: param.req,
            viewWebhookManager
        }, ncMeta);
        if (!param.viewWebhookManager) {
            (await viewWebhookManager.withNewViewId(modelView.id)).emit();
        }
    }
    constructor(appHooksService){
        this.appHooksService = appHooksService;
    }
};
KanbansService = _ts_decorate([
    (0, _common.Injectable)(),
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        typeof _apphooksservice.AppHooksService === "undefined" ? Object : _apphooksservice.AppHooksService
    ])
], KanbansService);
